module.exports = __webpack_public_path__ + "public/media/digital-vector2.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/digital-vector2.png
// module id = ./images/services/digital-vector2.png
// module chunks = 0